<script lang="ts">
  import type { Snippet } from 'svelte';
  import CheckCircleIcon from '~icons/feather/check-circle';
  import { fly } from 'svelte/transition';

  type Props = {
    bottom?: boolean;
    scrollOffset: number;
    scrollThreshold?: number;
    onClick: () => void;
    children: Snippet;
  }
  const props: Props = $props();
</script>

{#if !props.bottom && props.scrollOffset > (props.scrollThreshold ?? 0)}
  <div class="jump top" transition:fly={{ y: -100 }}>
    <button onclick={() => props.onClick()}>
      {@render props.children()}
    </button>
  </div>
{:else if props.bottom && props.scrollOffset < (props.scrollThreshold ?? 0)}
  <div class="jump bottom" transition:fly={{ y: 100 }}>
    <button onclick={() => props.onClick()}>
      {@render props.children()}
    </button>
  </div>
{/if}

<style lang="scss">
  @use '~/theme/theme';
  @use '~/theme/themify' as *;
  .jump {
    position: absolute;
    margin: 1em 0;
    left: 50%;
    &.top {
      top: 0;
    }
    &.bottom {
      bottom: 0;
    }
  }
  button {
    border: none;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    border-radius: 999px;
    padding: 0.5em 1em;
    transform: translate(-50%);
    display: flex;
    align-items: center;
    gap: 0.5em;
    box-shadow: 0 0 8px #00000040;
    @include themify {
      color: themed('text');
      background-color: themed('tile-blue');
    }
  }
</style>
